"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TranslationComponents = exports.TranslationModels = void 0;
const external_api_1 = require("./external-api");
const service_1 = __importDefault(require("./service"));
exports.TranslationModels = [
    service_1.default,
];
exports.TranslationComponents = [
    external_api_1.ExternalAPITranslation,
];
